import React, { useState, useEffect } from 'react';

import { 
    Datepicker, 
} from "components";

import { func_validation, isDateValid } from "functions";
import moment from 'moment';



export function useMiscellaneousInputs(props) {
    const { 
        isEditing,
        advancePaySetup,
        isFormSubmissionAttempted,
        chargeDetails,
    } = props;

    // Validate initial state values

    let startDateTime_init = func_validation.getObjectPropertyValue_stringTrimNotEmpty(advancePaySetup, "StartDateTime", "");
    if (isDateValid(startDateTime_init)) startDateTime_init = moment(startDateTime_init).date(1).format("YYYY-MM-DD");
    let nextBilledDatetime_init = func_validation.getObjectPropertyValue_stringTrimNotEmpty(advancePaySetup, "NextBillDateTime", "");
    if (isDateValid(nextBilledDatetime_init))  nextBilledDatetime_init = moment(nextBilledDatetime_init).date(1).format("YYYY-MM-DD");

    
    // States

    const [startDateTime, setStartBilledDate] = useState(startDateTime_init);
    const [nextBilledDatetime, setNextBilledDatetime] = useState(nextBilledDatetime_init);

    const [isComponentMounted, setIsComponentMounted] = useState(false);
    useEffect(() => { setIsComponentMounted(true); }, []);

    const [isAnyInputChanged, setIsAnyInputChanged] = useState(false);

    let billFrequence = chargeDetails?.BillFrequence;
    let billDiff = moment(nextBilledDatetime).diff(moment(startDateTime), "months");
    let isIncorrectBasedOnBillFrequence = !((billDiff == billFrequence) || (billDiff == 0));
    useEffect(() => {
        if (isComponentMounted && isDateValid(startDateTime)) {
            let startDateTimeMonth = moment(startDateTime).month();
            let newMonth = startDateTimeMonth + billFrequence;
            setNextBilledDatetime(moment(startDateTime).month(newMonth).format("YYYY-MM-DD"));
        }
    }, [billFrequence]);

    // Check for changes in input from initial
    useEffect(() => {
        let isNotChangedFromOriginal = (
            startDateTime === startDateTime_init &&
            nextBilledDatetime === nextBilledDatetime_init
        );

        let isChangedFromEmpty = (
            startDateTime || nextBilledDatetime
        )

        setIsAnyInputChanged(isEditing? !isNotChangedFromOriginal: isChangedFromEmpty);   
    }, [
        startDateTime, nextBilledDatetime
    ]);

    // List of number from 1 - 31 inclusive
    let lastBilledDateDay_options = [];
    for (let i = 1; i < 32; i++) {
        lastBilledDateDay_options.push(i);
    }

    // Display
    let display = (
        <div className="input-wrapper__miscellaneous d-flex flex-wrap">
            {/* Start Billed Date */}
            <Datepicker
                className={"miscellaneous__start-billed-date"}
                inputClassName={"start-billed-date__input"}
                
                label={"Start Date Time"}
                dateFromParent={startDateTime}
                defaultDate={startDateTime}
                dateFormat={"MM/yyyy"}
                handleOnChange={setStartBilledDate}

                isFormSubmissionAttempted={isFormSubmissionAttempted}
                errorMsg={"Required"}

                isConversionRequired_ISO8601 isInputRequired isMonthYear
            />

            {/* Next Billed Date */}
            <Datepicker
                className={"miscellaneous__next-billed-date"}
                inputClassName={"next-billed-date__input"}

                label={"Next Billed Date"}
                dateFromParent={nextBilledDatetime}
                defaultDate={nextBilledDatetime}
                dateFormat={"MM/yyyy"}
                handleOnChange={setNextBilledDatetime}

                customErrorValidation={(isIncorrectBasedOnBillFrequence && isEditing) || 
                    (!isEditing && isFormSubmissionAttempted && isIncorrectBasedOnBillFrequence) || 
                    (!nextBilledDatetime && isFormSubmissionAttempted)}
                errorMsg={isIncorrectBasedOnBillFrequence && nextBilledDatetime? "Must be " + billFrequence + " or 0 month(s) after Start Bill Date Time":"Required"}

                isConversionRequired_ISO8601 isInputRequired isMonthYear
            /> 
        </div>
    );

    let isEveryInputValid = (
        func_validation.isStringTrimNotEmpty(startDateTime) &&
        func_validation.isStringTrimNotEmpty(nextBilledDatetime) && !isIncorrectBasedOnBillFrequence
    );

    let miscellaneousDetails = {
        StartDateTime: startDateTime,
        NextBillDateTime: nextBilledDatetime,
    }

    return {
        miscellaneousDetails,

        isEveryInputValid,
        isAnyInputChanged,
        
        display
    }
}